import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@mui/material/Skeleton';

const GenericDropdown = ({
  tab,
  code,
  name,
  whfld,
  whval,
  whfld1,
  whval1,
  dropdownName,
  dropdownId,
  JSONKey,
  JSONValue,
  onChange
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState('');

  useEffect(() => {
   
    const buildQueryParams = () => {
      const params = new URLSearchParams();
      params.append("tab", tab);
      params.append("code", code);
      params.append("name", name);

      if (whfld && whval) {
      params.append("whfld", whfld);
      params.append("whval", whval);
      }

      if (whfld1 && whval1) {
        params.append("whfld1", whfld1);
        params.append("whval1", whval1);
      }
      return params.toString();
    };

    const fetchOptions = async () => {
      try {
        const query = buildQueryParams();
        const endpoint = `${process.env.REACT_APP_URL}/api/commission/options?${query}`;
        const response = await fetch(endpoint);
        const data = await response.json();
        setOptions(data);
      } catch (error) {
        console.error("Failed to fetch dropdown options:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOptions();
  }, [tab, code, name, whfld, whval, whfld1, whval1]);

  const handleChange = (e) => {
    setSelected(e.target.value);
    if (onChange) onChange(e);
  };

  return (
    <div>
      {loading ? (
        <Skeleton variant="rectangular" width={200} height={40} />
      ) : (
        <select name={dropdownName} id={dropdownId} value={selected} onChange={handleChange}>
          <option value="">--select--</option>
          {options.map((item) => (           
          <option key={item[JSONKey]} value={item[JSONKey]}>
            {item[JSONValue]}
          </option>
        ))}
        </select>
      )}
    </div>
  );
};

GenericDropdown.propTypes = {
  tab: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  whfld: PropTypes.string,
  whval: PropTypes.string,
  whfld1: PropTypes.string,
  whval1: PropTypes.string,
  dropdownName: PropTypes.string.isRequired,
  dropdownId: PropTypes.string.isRequired,
  onChange: PropTypes.func
};

export default GenericDropdown;
